import type { AppContext } from 'types/common'

import component from './Results.svelte'

export default function ({ stateRouter }: AppContext) {
	stateRouter.addState({
		name: 'app.interchange.results',
		route: 'results',
		querystringParameters: [
			'refresh',
			'inventoryTypeId',
			'year',
			'manufacturer',
			'model',
			'interchangeNumber',
			'subInterchangeNumber',
			'lastSearchType',
		],
		template: {
			svelte: true,
			component,
		},
		async resolve(
			_data,
			{ year, manufacturer, model, inventoryTypeId, interchangeNumber, subInterchangeNumber, lastSearchType },
		) {
			return Promise.resolve({
				inventoryTypeId: inventoryTypeId ? parseInt(inventoryTypeId, 10) : undefined,
				year: year ? parseInt(year, 10) : undefined,
				manufacturer,
				model,
				interchangeNumber,
				subInterchangeNumber,
				lastSearchType: lastSearchType ?? 'VEHICLE_INFO',
			})
		},
	})
}
